module.exports = __webpack_public_path__ + "static/media/cliente-agri-boi.0fe61ffe.webp";